export default __webpack_public_path__ + "c90825a15b154a9aae7ddb42f78bd485.png";